import { render } from "./InternalMedicinePage.vue?vue&type=template&id=6c3a6f8e"
import script from "./InternalMedicinePage.vue?vue&type=script&lang=js"
export * from "./InternalMedicinePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__